class FloatingSwatchesManager {
  constructor() {
    this.init();
    this.observeAjaxChanges(); // Observe AJAX changes to dynamically update the swatches
  }

  init() {
    this.checkAllVariantsOnLoad();

    this.handleSelectorChange = this.handleSelectorChange.bind(this);

    document.addEventListener('click', this.handleSelectorChange);
    // document.body.addEventListener('click', this.handleSelectorChange.bind(this));
  }

  checkAllVariantsOnLoad() {
    const allWrapperElements = document.querySelectorAll('.floating-swatches-wrapper');

    allWrapperElements.forEach(wrapper => {
      const productData = this.getProductJsonData(wrapper);
      if (!productData) return;

      productData.variants.forEach(variant => {
        const radioLabel = wrapper.querySelector(`.radio__button input[value="${variant.options}"]`);

        if (radioLabel) {
          if (!variant.available) {
            radioLabel.classList.add('sold-out');
          } else {
            radioLabel.classList.remove('sold-out');
          }
        }
      });
    });
  }

  handleSelectorChange(event) {
    const selectorWrapper = event.target.closest('.floating-swatches-wrapper');
    if (!selectorWrapper) return;

    if (event.target.matches('.product__selectors input')) {
      this.updateVariant(event.target, selectorWrapper);
    }
  }

  updateVariant(input, wrapper) {
    const variantInput = wrapper.querySelector('input[name="id"]');

    const productData = this.getProductJsonData(wrapper);

    if (!productData || !variantInput) return;

    const selectedValue = input.value;

    /*
    * In the grid flow, the user selects Size.
    *
    * Find the available variant whose Size matches.
    */
    const sizePosition = this.getSizeOptionPosition(wrapper);

    let variant = null;

    if (sizePosition !== null) {
      variant =productData.variants.find(v =>v.available &&v.options[sizePosition - 1] === selectedValue);
    }

    /*
    * Fallback to old behavior.
    */
    if (!variant) {
      variant = productData.variants.find(v => v.options.includes(selectedValue));
    }

    if (variant) {
      variantInput.value = variant.id;
      this.updateAddToCartButton(variant,wrapper);
    } else {
      this.updateAddToCartButton(null,wrapper);
    }
  }

  getSizeOptionPosition(wrapper) {
    const sizeInput = wrapper.querySelector('[data-option-name="Size"]');

    if (!sizeInput) {
      return null;
    }

    const position = parseInt(sizeInput.dataset.optionPosition,10);

    return Number.isNaN(position)? null : position;
  }

  updateAddToCartButton(variant, wrapper) {
    const addToCartButton = wrapper.querySelector('[data-add-to-cart]');
    const addToCartText = wrapper.querySelector('[data-add-to-cart-text]');
    const formWrapper = wrapper.querySelector('[data-form-wrapper]');

    if (!addToCartButton || !addToCartText) return;

    if (!variant || !variant.available) {
      addToCartButton.disabled = true;
      addToCartText.textContent = 'Sold Out';
      formWrapper.classList.add('variant--soldout');
    } else {
      addToCartButton.disabled = false;
      addToCartText.textContent = 'Add to cart';
      formWrapper.classList.remove('variant--soldout');
      addToCartButton.click();
      
      this.cartLoadingState(formWrapper)
    }
  }

  cartLoadingState(formWrapper){
    const inner_form = formWrapper.querySelector(".form__inner__wrapper");
    let loading_state = formWrapper.querySelector(".add-cart-loading");
    inner_form.style.display = "none";
    loading_state.style.display = "block";

    setTimeout(function(){
      inner_form.style.display = "block";
      loading_state.style.display = "none";
    }, 700)
  }

  getProductJsonData(wrapper) {
    /*
    * If user selected another Color,
    * use the variants of that Color product.
    */
    if (
      wrapper._selectedColorProduct
    ) {
      return wrapper._selectedColorProduct;
    }

    /*
     * Otherwise use the original
     * product JSON.
     */
    const scriptElement = wrapper.querySelector('script[data-product-json]');
    if (!scriptElement) return null;

    try {
      return JSON.parse(scriptElement.innerText);
    } catch (error) {
      console.error('Failed to parse product JSON data:', error);
      return null;
    }
  }

  observeAjaxChanges() {
    const productsGrid = document.querySelector('[data-products-grid]');
    if (!productsGrid) {
      return;
    }

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          this.checkAllVariantsOnLoad(); // Reinitialize floating swatches
        }
      });
    });

    observer.observe(productsGrid, {
      childList: true, // Watch for added/removed children
      subtree: true    // Watch for changes in descendants
    });
  }
}

// Initialize the class
document.addEventListener('DOMContentLoaded', () => {
  new FloatingSwatchesManager();
});
